import { render, staticRenderFns } from "./VaimoProducts.vue?vue&type=template&id=cb4152b2&scoped=true&"
import script from "./VaimoProducts.vue?vue&type=script&lang=ts&"
export * from "./VaimoProducts.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoProducts.vue?vue&type=style&index=0&id=cb4152b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4152b2",
  null
  
)

export default component.exports